/* Leaft Blade V2 — header: mobile menu toggle + cart-drawer open + live count. */
(() => {
  const header = document.querySelector('[data-lb2-header]');
  if (!header) return;

  const toggle = header.querySelector('[data-lb2-menu-toggle]');
  const nav = header.querySelector('.lb2-header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Open the cart drawer instead of navigating, when the drawer exists.
  const cartLink = header.querySelector('[data-lb2-cart-link]');
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (cartLink && drawer) {
    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof drawer.open === 'function') drawer.open();
    });
  }

  // Keep the header count in sync with cart updates (Shopify standard events).
  // The event carries a deferred promise that resolves with the fresh cart.
  document.addEventListener('shopify:cart:lines-update', (event) => {
    const promise = event.promise || (event.detail && event.detail.promise);
    if (!promise || typeof promise.then !== 'function') return;
    promise
      .then((result) => {
        // The resolved cart is Storefront-shaped: the count is totalQuantity.
        const count = (result && result.cart && result.cart.totalQuantity) ?? (result && result.detail && result.detail.itemCount);
        const el = header.querySelector('[data-lb2-cart-count]');
        if (el && typeof count === 'number') {
          el.textContent = count;
          el.hidden = count === 0;
        }
      })
      .catch(() => {});
  });
})();
